"use client";
import Image from "next/image";
import Link from "next/link";
import { VStack, Box } from "@chakra-ui/react";
import DataCentersImg from "public/home/dataCentersMap.png";
import { useHeadingVariant, useTextVariant } from "@/theme/hooks/useSectionStyle";
import { Heading, Text } from "@/elements";
import { MAIN_ROUTES } from "@/constants/routes";
import { DATA_CENTER_CONSTANTS } from "./constants";

type Props = { asLink?: boolean };

const DataCenterMap = (props: Props) => {
  const { asLink = true } = props;
  const headingVariant = useHeadingVariant();
  const textVariant = useTextVariant();
  return (
    <VStack gap={6}>
      <Heading as="h3" variant={headingVariant}>
        {DATA_CENTER_CONSTANTS.TITLE}
      </Heading>
      <Text
        variant={textVariant}
        noOfLines={2}
        color="text.100"
        whiteSpace="pre-line"
        textAlign={"center"}
      >
        {DATA_CENTER_CONSTANTS.SUB_TITLE}
      </Text>
      <Box as={asLink ? Link : "div"} {...{ href: MAIN_ROUTES.DATA_CENTER }}>
        <Image
          src={DataCentersImg}
          alt="data Centers"
          style={{ height: "auto", maxWidth: "1200px", width: "100%" }}
        />
      </Box>
    </VStack>
  );
};

export default DataCenterMap;
